export default __webpack_public_path__ + "static/media/MarViva.fc1e65e6.png";